import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useChatNotification } from '../../contexts/ChatNotificationContext';
import {
  fetchChatCanais,
  fetchChatMensagens,
  enviarChatMensagem,
  editarChatMensagem,
  deletarChatMensagem,
  marcarChatComoLida,
  fetchChatPresenca,
  setChatPresenca,
  criarChatCanal,
  criarOuObterDM,
  fetchChatUsuarios,
  removerChatDM,
  fetchMembrosGrupo,
  adicionarMembrosGrupo,
  removerMembroGrupo,
  sairDoGrupo,
  excluirGrupo,
  reagirChatMensagem
} from '../../services/api';

// Emojis disponíveis para reação (devem casar com EMOJIS_REACAO do backend)
const EMOJIS_REACAO = ['👍', '❤️', '😂', '😮', '😢', '🙏', '🔥', '🎉'];
import styles from './ChatPage.module.css';

// Cores dos avatares baseadas no ID
const AVATAR_CORES = [
  'linear-gradient(135deg, #6366f1, #8b5cf6)',
  'linear-gradient(135deg, #f43f5e, #ec4899)',
  'linear-gradient(135deg, #06b6d4, #3b82f6)',
  'linear-gradient(135deg, #10b981, #059669)',
  'linear-gradient(135deg, #f59e0b, #d97706)',
  'linear-gradient(135deg, #8b5cf6, #d946ef)',
  'linear-gradient(135deg, #14b8a6, #06b6d4)',
  'linear-gradient(135deg, #ef4444, #f97316)'
];

// ── Ícones SVG (substituem os emojis de interface; herdam a cor via currentColor) ──
const svgI = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
const Icon = {
  chat: (p) => (<svg {...svgI} {...p}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>),
  search: (p) => (<svg {...svgI} {...p}><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></svg>),
  close: (p) => (<svg {...svgI} {...p}><path d="M18 6 6 18M6 6l12 12" /></svg>),
  send: (p) => (<svg {...svgI} {...p}><path d="M22 2 11 13M22 2l-7 20-4-9-9-4z" /></svg>),
  attach: (p) => (<svg {...svgI} {...p}><path d="M21.44 11.05 12.25 20.24a5 5 0 0 1-7.07-7.07l9.19-9.19a3 3 0 0 1 4.24 4.24l-9.2 9.19a1 1 0 0 1-1.41-1.41l8.49-8.49" /></svg>),
  mic: (p) => (<svg {...svgI} {...p}><rect x="9" y="2" width="6" height="12" rx="3" /><path d="M5 10a7 7 0 0 0 14 0M12 19v3" /></svg>),
  stop: (p) => (<svg {...svgI} {...p}><rect x="6" y="6" width="12" height="12" rx="2" /></svg>),
  trash: (p) => (<svg {...svgI} {...p}><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /></svg>),
  edit: (p) => (<svg {...svgI} {...p}><path d="M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" /></svg>),
  reply: (p) => (<svg {...svgI} {...p}><path d="M9 17 4 12l5-5M4 12h12a4 4 0 0 1 4 4v2" /></svg>),
  smile: (p) => (<svg {...svgI} {...p}><circle cx="12" cy="12" r="9" /><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" /></svg>),
  users: (p) => (<svg {...svgI} {...p}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>),
  bot: (p) => (<svg {...svgI} {...p}><rect x="3" y="8" width="18" height="12" rx="2" /><path d="M12 8V4M8 2h8M8.5 13v1M15.5 13v1" /></svg>),
  arrowUp: (p) => (<svg {...svgI} {...p}><path d="M12 19V5M5 12l7-7 7 7" /></svg>),
  arrowLeft: (p) => (<svg {...svgI} {...p}><path d="M19 12H5M12 19l-7-7 7-7" /></svg>),
  arrowRight: (p) => (<svg {...svgI} {...p}><path d="M5 12h14M12 5l7 7-7 7" /></svg>),
  check: (p) => (<svg {...svgI} {...p}><path d="M20 6 9 17l-5-5" /></svg>),
  image: (p) => (<svg {...svgI} {...p}><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="9" cy="9" r="2" /><path d="m21 15-5-5L5 21" /></svg>),
  hash: (p) => (<svg {...svgI} {...p}><path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18" /></svg>),
  leave: (p) => (<svg {...svgI} {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" /></svg>),
  sparkles: (p) => (<svg {...svgI} {...p}><path d="m12 3 1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2z" /></svg>),
};

const getAvatarCor = (id) => AVATAR_CORES[(id || 0) % AVATAR_CORES.length];
const getIniciais = (nome) => {
  if (!nome) return '?';
  const partes = nome.trim().split(' ');
  if (partes.length >= 2) return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
  return nome.substring(0, 2).toUpperCase();
};

// Converte string de data do SQLite (UTC sem marcador) para Date correto
const parseDataUTC = (data) => {
  if (!data) return null;
  // Se a string não tem indicador de timezone, adicionar 'Z' para forçar UTC
  // SQLite CURRENT_TIMESTAMP salva em UTC sem o sufixo
  let str = String(data).trim();
  if (!str.endsWith('Z') && !str.includes('+') && !str.includes('T')) {
    // Formato SQLite: "2026-04-13 17:37:00" → "2026-04-13T17:37:00Z"
    str = str.replace(' ', 'T') + 'Z';
  } else if (!str.endsWith('Z') && str.includes('T') && !str.includes('+')) {
    str = str + 'Z';
  }
  return new Date(str);
};

const formatarHora = (data) => {
  if (!data) return '';
  const d = parseDataUTC(data);
  if (!d || isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

const formatarData = (data) => {
  if (!data) return '';
  const d = parseDataUTC(data);
  if (!d || isNaN(d.getTime())) return '';
  const hoje = new Date();
  const ontem = new Date(hoje);
  ontem.setDate(ontem.getDate() - 1);

  if (d.toDateString() === hoje.toDateString()) return 'Hoje';
  if (d.toDateString() === ontem.toDateString()) return 'Ontem';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
};

const comprimirImagem = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const img = new Image();
    img.onload = () => {
      const MAX = 1024;
      let w = img.width, h = img.height;
      if (w > MAX || h > MAX) {
        if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
        else { w = Math.round(w * MAX / h); h = MAX; }
      }
      const canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL('image/jpeg', 0.82));
    };
    img.onerror = reject;
    img.src = e.target.result;
  };
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

const ChatPage = () => {
  const { user } = useAuth();
  const { socketRef, atualizarNaoLidas } = useChatNotification();
  const [canais, setCanais] = useState([]);
  const [canalAtivo, setCanalAtivo] = useState(null);
  const [mensagens, setMensagens] = useState([]);
  const [temMais, setTemMais] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [inputMsg, setInputMsg] = useState('');
  const [respondendoA, setRespondendoA] = useState(null);
  const [editandoMsg, setEditandoMsg] = useState(null);
  const [digitandoUsuarios, setDigitandoUsuarios] = useState({});
  const [leituras, setLeituras] = useState({});        // usuario_id → última msg lida
  const [totalMembros, setTotalMembros] = useState(0);
  const [buscaMsg, setBuscaMsg] = useState('');        // termo de busca na conversa
  const [buscaAtiva, setBuscaAtiva] = useState(false);
  const [presenca, setPresenca] = useState([]);
  const [meuStatus, setMeuStatus] = useState('online');
  const [showDetalhes, setShowDetalhes] = useState(false);
  const [showNovoCanal, setShowNovoCanal] = useState(false);
  const [showNovoDM, setShowNovoDM] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [novoCanal, setNovoCanal] = useState({ nome: '', descricao: '' });
  const [buscaSidebar, setBuscaSidebar] = useState('');
  const [todosUsuarios, setTodosUsuarios] = useState([]);
  const [buscaCarregada, setBuscaCarregada] = useState(false);

  const [imagemPendente, setImagemPendente] = useState(null); // data URL da imagem a enviar
  const [imagemZoom, setImagemZoom] = useState(null); // lightbox
  const [audioPendente, setAudioPendente] = useState(null); // data URL do áudio a enviar
  const [gravandoAudio, setGravandoAudio] = useState(false);
  const [duracaoGravacao, setDuracaoGravacao] = useState(0);

  // ---- Grupo ----
  const [showCriarGrupo, setShowCriarGrupo] = useState(false);
  const [grupoEtapa, setGrupoEtapa] = useState(1); // 1 = nome/desc, 2 = selecionar membros
  const [novoGrupo, setNovoGrupo] = useState({ nome: '', descricao: '' });
  const [grupoMembrosSelecionados, setGrupoMembrosSelecionados] = useState([]);
  const [grupoUsuariosDisponiveis, setGrupoUsuariosDisponiveis] = useState([]);
  const [grupoBusca, setGrupoBusca] = useState('');
  const [showAdicionarMembro, setShowAdicionarMembro] = useState(false);
  const [addMembroBusca, setAddMembroBusca] = useState('');
  const [addMembroUsuarios, setAddMembroUsuarios] = useState([]);
  const [addMembroSelecionados, setAddMembroSelecionados] = useState([]);
  const [membrosGrupoAtivo, setMembrosGrupoAtivo] = useState([]);
  const [editandoGrupo, setEditandoGrupo] = useState(false);
  const [grupoEditNome, setGrupoEditNome] = useState('');
  const [grupoEditDescricao, setGrupoEditDescricao] = useState('');

  const mensagensRef = useRef(null);
  const inputRef = useRef(null);
  const digitandoTimerRef = useRef(null);
  const fileInputRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const gravacaoTimerRef = useRef(null);

  // ============================================
  // CARREGAR DADOS INICIAIS
  // ============================================
  const carregarCanais = useCallback(async () => {
    const result = await fetchChatCanais();
    if (result.success) {
      setCanais(result.data);
      // Entrar nos rooms via socket
      if (socketRef.current) {
        socketRef.current.emit('join-canais', {
          canalIds: result.data.map(c => c.id)
        });
      }
    }
  }, [socketRef]);

  // ============================================
  // REGISTRAR HANDLERS DO SOCKET PARA A PÁGINA
  // O som de notificação já é tratado no Context global!
  // Aqui só registramos os handlers de UI da página
  // ============================================
  useEffect(() => {
    const socket = socketRef.current;
    if (!socket || !user) return;

    // Handler: nova mensagem — atualizar lista de mensagens
    const onNovaMensagem = (mensagem) => {
      setMensagens(prev => {
        // Evitar duplicatas
        if (prev.find(m => m.id === mensagem.id)) return prev;
        return [...prev, mensagem];
      });
      // Atualizar canais
      carregarCanais();
    };

    // Handler: mensagem editada
    const onMensagemEditada = (msgAtualizada) => {
      setMensagens(prev => prev.map(m => m.id === msgAtualizada.id ? { ...m, ...msgAtualizada } : m));
    };

    // Handler: mensagem deletada
    const onMensagemDeletada = ({ id }) => {
      setMensagens(prev => prev.map(m => m.id === id ? { ...m, deletada: 1, conteudo: '[Mensagem removida]' } : m));
    };

    // Handler: digitando
    const onUsuarioDigitando = ({ canalId, usuario_id, nome }) => {
      setDigitandoUsuarios(prev => ({
        ...prev,
        [`${canalId}_${usuario_id}`]: { nome, timestamp: Date.now() }
      }));
    };

    const onUsuarioParouDigitar = ({ canalId, usuario_id }) => {
      setDigitandoUsuarios(prev => {
        const novo = { ...prev };
        delete novo[`${canalId}_${usuario_id}`];
        return novo;
      });
    };

    // Handler: presença
    const onPresencaAtualizada = ({ usuario_id, nome, status }) => {
      setPresenca(prev => prev.map(u =>
        u.id === usuario_id ? { ...u, status } : u
      ));
      // Atualizar nos canais DM
      setCanais(prev => prev.map(c => {
        if (c.tipo === 'dm' && c.dm_usuario?.id === usuario_id) {
          return { ...c, dm_usuario: { ...c.dm_usuario, status_presenca: status } };
        }
        return c;
      }));
    };

    // Handler: reação atualizada numa mensagem
    const onReacaoAtualizada = ({ mensagem_id, reacoes }) => {
      setMensagens(prev => prev.map(m => m.id === mensagem_id ? { ...m, reacoes } : m));
    };

    // Handler: canal lido por alguém — atualiza indicadores ✓✓
    const onCanalLido = ({ usuario_id, ultima_mensagem_id }) => {
      setLeituras(prev => {
        if ((prev[usuario_id] || 0) >= ultima_mensagem_id) return prev;
        return { ...prev, [usuario_id]: ultima_mensagem_id };
      });
    };

    // Registrar todos os handlers
    socket.on('nova-mensagem', onNovaMensagem);
    socket.on('mensagem-editada', onMensagemEditada);
    socket.on('mensagem-deletada', onMensagemDeletada);
    socket.on('usuario-digitando', onUsuarioDigitando);
    socket.on('usuario-parou-digitar', onUsuarioParouDigitar);
    socket.on('presenca-atualizada', onPresencaAtualizada);
    socket.on('reacao-atualizada', onReacaoAtualizada);
    socket.on('canal-lido', onCanalLido);

    return () => {
      // Limpar handlers ao desmontar a página
      socket.off('nova-mensagem', onNovaMensagem);
      socket.off('mensagem-editada', onMensagemEditada);
      socket.off('mensagem-deletada', onMensagemDeletada);
      socket.off('usuario-digitando', onUsuarioDigitando);
      socket.off('usuario-parou-digitar', onUsuarioParouDigitar);
      socket.off('presenca-atualizada', onPresencaAtualizada);
      socket.off('reacao-atualizada', onReacaoAtualizada);
      socket.off('canal-lido', onCanalLido);
    };
  }, [socketRef, user, carregarCanais]);



  useEffect(() => {
    carregarCanais();
    carregarPresenca();
    // Definir presença como online
    setChatPresenca('online');
    setMeuStatus('online');
  }, [carregarCanais]);

  const carregarPresenca = async () => {
    const result = await fetchChatPresenca();
    if (result.success) setPresenca(result.data);
  };

  // ============================================
  // CARREGAR MENSAGENS DO CANAL
  // ============================================
  const carregarMensagens = useCallback(async (canalId, antes = null) => {
    setCarregando(true);
    const result = await fetchChatMensagens(canalId, { antes });
    if (result.success) {
      if (antes) {
        setMensagens(prev => [...result.data, ...prev]);
      } else {
        setMensagens(result.data);
        // Estado de leitura do canal (indicadores ✓✓)
        if (Array.isArray(result.leituras)) {
          const mapa = {};
          for (const l of result.leituras) mapa[l.usuario_id] = l.ultima_mensagem_id;
          setLeituras(mapa);
        }
        if (result.total_membros) setTotalMembros(result.total_membros);
      }
      setTemMais(result.temMais);
    }
    setCarregando(false);
  }, []);

  // Reagir a uma mensagem (toggle otimista — o socket reconcilia o real)
  const handleReagir = useCallback(async (msg, emoji) => {
    setMensagens(prev => prev.map(m => {
      if (m.id !== msg.id) return m;
      const reacoes = Array.isArray(m.reacoes)
        ? m.reacoes.map(r => ({ ...r, usuarios: [...(r.usuarios || [])] }))
        : [];
      const idx = reacoes.findIndex(r => r.emoji === emoji);
      if (idx >= 0) {
        const uIdx = reacoes[idx].usuarios.indexOf(user.id);
        if (uIdx >= 0) reacoes[idx].usuarios.splice(uIdx, 1);
        else reacoes[idx].usuarios.push(user.id);
        if (reacoes[idx].usuarios.length === 0) reacoes.splice(idx, 1);
      } else {
        reacoes.push({ emoji, usuarios: [user.id] });
      }
      return { ...m, reacoes };
    }));
    await reagirChatMensagem(msg.id, emoji);
  }, [user]);

  // Ao selecionar canal
  const selecionarCanal = useCallback(async (canal) => {
    setCanalAtivo(canal);
    setMensagens([]);
    setRespondendoA(null);
    setEditandoMsg(null);
    setInputMsg('');
    await carregarMensagens(canal.id);

    // Entrar no room do canal
    if (socketRef.current) {
      socketRef.current.emit('join-canal', { canalId: canal.id });
    }

    // Marcar como lido
    if (canal.nao_lidas > 0 && canal.ultima_msg_id) {
      await marcarChatComoLida(canal.id, canal.ultima_msg_id);
      setCanais(prev => prev.map(c => c.id === canal.id ? { ...c, nao_lidas: 0 } : c));
      atualizarNaoLidas(); // Atualizar badge global da sidebar
    }
  }, [carregarMensagens, socketRef, atualizarNaoLidas]);

  // Scroll automático para baixo
  useEffect(() => {
    if (mensagensRef.current) {
      const el = mensagensRef.current;
      // Só auto-scroll se está perto do fim
      const isProximoDoFim = el.scrollHeight - el.scrollTop - el.clientHeight < 200;
      if (isProximoDoFim || mensagens.length <= 50) {
        el.scrollTop = el.scrollHeight;
      }
    }
  }, [mensagens]);

  // Marcar como lido ao visualizar
  useEffect(() => {
    if (canalAtivo && mensagens.length > 0) {
      const ultimaMsg = mensagens[mensagens.length - 1];
      if (ultimaMsg && ultimaMsg.id) {
        marcarChatComoLida(canalAtivo.id, ultimaMsg.id);
        atualizarNaoLidas(); // Atualizar badge global da sidebar
      }
    }
  }, [mensagens, canalAtivo, atualizarNaoLidas]);

  // ============================================
  // ENVIAR / EDITAR MENSAGEM
  // ============================================
  const handleAnexarImagem = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { alert('Apenas imagens são permitidas.'); return; }
    if (file.size > 10 * 1024 * 1024) { alert('Imagem muito grande. Máximo 10MB.'); return; }
    try {
      const dataUrl = await comprimirImagem(file);
      setImagemPendente(dataUrl);
    } catch {
      alert('Erro ao processar imagem.');
    }
    e.target.value = '';
  };

  const handleEnviar = async () => {
    if (!inputMsg.trim() && !imagemPendente && !audioPendente) return;
    if (!canalAtivo) return;

    if (editandoMsg) {
      // Editar (texto apenas)
      const result = await editarChatMensagem(editandoMsg.id, inputMsg.trim());
      if (result.success) {
        setMensagens(prev => prev.map(m => m.id === editandoMsg.id ? { ...m, ...result.data } : m));
      }
      setEditandoMsg(null);
    } else {
      // Enviar nova
      const result = await enviarChatMensagem(canalAtivo.id, {
        conteudo: inputMsg.trim(),
        resposta_a: respondendoA?.id || null,
        imagem: imagemPendente || null,
        audio: audioPendente || null
      });
      if (result.success) {
        setMensagens(prev => {
          if (prev.find(m => m.id === result.data.id)) return prev;
          return [...prev, result.data];
        });
        carregarCanais(); // Atualizar última msg
      }
      setRespondendoA(null);
      setImagemPendente(null);
      setAudioPendente(null);
    }

    setInputMsg('');
    inputRef.current?.focus();

    // Parar indicador de digitação
    if (socketRef.current && canalAtivo) {
      socketRef.current.emit('parou-digitar', {
        canalId: canalAtivo.id,
        usuario: { id: user.id }
      });
    }
  };

  // ============================================
  // GRAVAÇÃO DE ÁUDIO (Web MediaRecorder)
  // ============================================
  const iniciarGravacaoAudio = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = () => {
        const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
        // Converter para base64
        const reader = new FileReader();
        reader.onloadend = () => {
          setAudioPendente(reader.result);
        };
        reader.readAsDataURL(blob);
        // Parar tracks do microfone
        stream.getTracks().forEach(t => t.stop());
      };

      mediaRecorderRef.current = mediaRecorder;
      mediaRecorder.start();
      setGravandoAudio(true);
      setDuracaoGravacao(0);

      gravacaoTimerRef.current = setInterval(() => {
        setDuracaoGravacao(prev => {
          if (prev >= 59) {
            pararGravacaoAudio();
            return prev;
          }
          return prev + 1;
        });
      }, 1000);
    } catch (err) {
      console.error('Erro ao acessar microfone:', err);
      alert('Não foi possível acessar o microfone. Verifique as permissões do navegador.');
    }
  };

  const pararGravacaoAudio = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      mediaRecorderRef.current.stop();
    }
    setGravandoAudio(false);
    if (gravacaoTimerRef.current) clearInterval(gravacaoTimerRef.current);
  };

  const cancelarGravacaoAudio = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      // Remover o handler onstop para não salvar
      mediaRecorderRef.current.onstop = () => {
        // Parar tracks do microfone sem salvar
        mediaRecorderRef.current.stream?.getTracks().forEach(t => t.stop());
      };
      mediaRecorderRef.current.stop();
    }
    setGravandoAudio(false);
    setAudioPendente(null);
    if (gravacaoTimerRef.current) clearInterval(gravacaoTimerRef.current);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleEnviar();
    }
    if (e.key === 'Escape') {
      setRespondendoA(null);
      setEditandoMsg(null);
      setInputMsg('');
    }
  };

  const handlePaste = async (e) => {
    const items = e.clipboardData?.items;
    if (!items) return;
    for (const item of items) {
      if (item.type.startsWith('image/')) {
        e.preventDefault();
        const file = item.getAsFile();
        if (!file) return;
        try {
          const dataUrl = await comprimirImagem(file);
          setImagemPendente(dataUrl);
        } catch {
          alert('Erro ao processar imagem colada.');
        }
        return;
      }
    }
  };

  // Indicador de digitação
  const handleInputChange = (e) => {
    setInputMsg(e.target.value);

    if (socketRef.current && canalAtivo) {
      socketRef.current.emit('digitando', {
        canalId: canalAtivo.id,
        usuario: { id: user.id, nome: user.nome }
      });

      // Parar após 2s sem digitar
      if (digitandoTimerRef.current) clearTimeout(digitandoTimerRef.current);
      digitandoTimerRef.current = setTimeout(() => {
        socketRef.current?.emit('parou-digitar', {
          canalId: canalAtivo.id,
          usuario: { id: user.id }
        });
      }, 2000);
    }
  };

  // ============================================
  // AÇÕES DE MENSAGEM
  // ============================================
  const handleResponder = (msg) => {
    setRespondendoA(msg);
    setEditandoMsg(null);
    inputRef.current?.focus();
  };

  const handleEditar = (msg) => {
    setEditandoMsg(msg);
    setInputMsg(msg.conteudo);
    setRespondendoA(null);
    inputRef.current?.focus();
  };

  const handleDeletar = async (msg) => {
    if (!confirm('Tem certeza que deseja remover esta mensagem?')) return;
    await deletarChatMensagem(msg.id);
    setMensagens(prev => prev.map(m => m.id === msg.id ? { ...m, deletada: 1, conteudo: '[Mensagem removida]' } : m));
  };

  // ============================================
  // STATUS DE PRESENÇA
  // ============================================
  const handleMudarStatus = async (novoStatus) => {
    setMeuStatus(novoStatus);
    await setChatPresenca(novoStatus);
  };

  // ============================================
  // MODAL NOVO CANAL
  // ============================================
  const handleCriarCanal = async () => {
    if (!novoCanal.nome.trim()) return;
    const result = await criarChatCanal({
      nome: novoCanal.nome.trim(),
      descricao: novoCanal.descricao.trim()
    });
    if (result.success) {
      setShowNovoCanal(false);
      setNovoCanal({ nome: '', descricao: '' });
      carregarCanais();
    }
  };

  // ============================================
  // NOVO DM
  // ============================================
  const handleNovoDM = async (usuarioId) => {
    const result = await criarOuObterDM(usuarioId);
    if (result.success) {
      setShowNovoDM(false);
      await carregarCanais();
      // Selecionar o canal DM
      const canaisAtualizados = await fetchChatCanais();
      if (canaisAtualizados.success) {
        setCanais(canaisAtualizados.data);
        const dmCanal = canaisAtualizados.data.find(c => c.id === result.data.canal_id);
        if (dmCanal) selecionarCanal(dmCanal);
      }
    }
  };

  const abrirNovoDM = async () => {
    const result = await fetchChatUsuarios();
    if (result.success) {
      setUsuarios(result.data.filter(u => u.id !== user?.id));
      setShowNovoDM(true);
    }
  };

  // ============================================
  // BUSCA DE USUÁRIOS DO SISTEMA
  // ============================================
  const handleBuscaChange = async (valor) => {
    setBuscaSidebar(valor);
    // Carregar todos os usuários na primeira busca
    if (valor.trim() && !buscaCarregada) {
      const result = await fetchChatUsuarios();
      if (result.success) {
        setTodosUsuarios(result.data.filter(u => u.id !== user?.id));
        setBuscaCarregada(true);
      }
    }
  };

  const handleSelecionarUsuarioBusca = async (usuarioId) => {
    setBuscaSidebar('');
    const result = await criarOuObterDM(usuarioId);
    if (result.success) {
      await carregarCanais();
      const canaisAtualizados = await fetchChatCanais();
      if (canaisAtualizados.success) {
        setCanais(canaisAtualizados.data);
        const dmCanal = canaisAtualizados.data.find(c => c.id === result.data.canal_id);
        if (dmCanal) selecionarCanal(dmCanal);
      }
    }
  };

  // ============================================
  // GRUPO — CRIAR
  // ============================================
  const abrirCriarGrupo = async () => {
    const result = await fetchChatUsuarios();
    if (result.success) {
      setGrupoUsuariosDisponiveis(result.data.filter(u => u.id !== user?.id));
    }
    setNovoGrupo({ nome: '', descricao: '' });
    setGrupoMembrosSelecionados([]);
    setGrupoBusca('');
    setGrupoEtapa(1);
    setShowCriarGrupo(true);
  };

  const toggleGrupoMembro = (uid) => {
    setGrupoMembrosSelecionados(prev =>
      prev.includes(uid) ? prev.filter(id => id !== uid) : [...prev, uid]
    );
  };

  const handleCriarGrupo = async () => {
    if (!novoGrupo.nome.trim() || grupoMembrosSelecionados.length === 0) return;
    const result = await criarChatCanal({
      nome: novoGrupo.nome.trim(),
      descricao: novoGrupo.descricao.trim(),
      membros: grupoMembrosSelecionados
    });
    if (result.success) {
      setShowCriarGrupo(false);
      await carregarCanais();
    }
  };

  // ============================================
  // GRUPO — GESTÃO DE MEMBROS
  // ============================================
  const carregarMembrosGrupo = async (canalId) => {
    const result = await fetchMembrosGrupo(canalId);
    if (result.success) {
      setMembrosGrupoAtivo(result.data);
    }
  };

  const abrirAdicionarMembro = async () => {
    const result = await fetchChatUsuarios();
    if (result.success && canalAtivo) {
      // Filtrar quem já é membro
      const membrosIds = membrosGrupoAtivo.map(m => m.id);
      setAddMembroUsuarios(result.data.filter(u => !membrosIds.includes(u.id)));
      setAddMembroSelecionados([]);
      setAddMembroBusca('');
      setShowAdicionarMembro(true);
    }
  };

  const handleAdicionarMembros = async () => {
    if (!canalAtivo || addMembroSelecionados.length === 0) return;
    const result = await adicionarMembrosGrupo(canalAtivo.id, addMembroSelecionados);
    if (result.success) {
      setShowAdicionarMembro(false);
      await carregarMembrosGrupo(canalAtivo.id);
      await carregarCanais();
    }
  };

  const handleRemoverMembro = async (usuarioId, nome) => {
    if (!canalAtivo) return;
    if (!confirm(`Remover ${nome} do grupo?`)) return;
    const result = await removerMembroGrupo(canalAtivo.id, usuarioId);
    if (result.success) {
      await carregarMembrosGrupo(canalAtivo.id);
      await carregarCanais();
    }
  };

  const handleSairDoGrupo = async () => {
    if (!canalAtivo) return;
    if (!confirm('Tem certeza que deseja sair deste grupo?')) return;
    const result = await sairDoGrupo(canalAtivo.id);
    if (result.success) {
      setCanalAtivo(null);
      setShowDetalhes(false);
      await carregarCanais();
    }
  };

  const handleExcluirGrupo = async () => {
    if (!canalAtivo) return;
    const nomeGrupo = canalAtivo.nome;
    if (!confirm(`⚠️ Tem certeza que deseja excluir o grupo "${nomeGrupo}"?\n\nTodos os membros serão removidos.\nAs mensagens serão preservadas no banco de dados.`)) return;
    const result = await excluirGrupo(canalAtivo.id);
    if (result.success) {
      setCanalAtivo(null);
      setShowDetalhes(false);
      await carregarCanais();
      alert(`Grupo "${nomeGrupo}" excluído com sucesso. As mensagens foram preservadas.`);
    } else {
      alert(result.message || 'Erro ao excluir grupo');
    }
  };

  // Salvar edição de nome/descrição do grupo (somente admin)
  const handleSalvarEdicaoGrupo = async () => {
    if (!canalAtivo) return;
    if (!grupoEditNome.trim()) { alert('O nome do grupo não pode ficar vazio.'); return; }
    const result = await editarGrupo(canalAtivo.id, {
      nome: grupoEditNome.trim(),
      descricao: grupoEditDescricao.trim(),
      icone: canalAtivo.icone || ''
    });
    if (result.success) {
      setCanalAtivo(prev => ({ ...prev, nome: grupoEditNome.trim(), descricao: grupoEditDescricao.trim() }));
      setEditandoGrupo(false);
      await carregarCanais();
    } else {
      alert(result.message || 'Erro ao salvar alterações');
    }
  };

  // Ao selecionar canal de grupo, carregar membros
  useEffect(() => {
    if (canalAtivo && canalAtivo.tipo === 'grupo' && !canalAtivo.is_canal_fixo) {
      carregarMembrosGrupo(canalAtivo.id);
    } else {
      setMembrosGrupoAtivo([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canalAtivo?.id]);

  // ============================================
  // RENDERIZAÇÃO — LISTA DE CANAIS
  // ============================================
  const termoBusca = buscaSidebar.trim().toLowerCase();
  const canaisIA = canais.filter(c => c.tipo === 'ia');
  const canaisFixos = canais.filter(c => c.tipo === 'grupo' && c.is_canal_fixo);
  const canaisGruposPersonalizados = canais.filter(c => c.tipo === 'grupo' && !c.is_canal_fixo);
  const canaisDM = canais.filter(c => c.tipo === 'dm');

  // Resultados da busca de usuários
  const resultadosBusca = termoBusca
    ? todosUsuarios.filter(u => u.nome.toLowerCase().includes(termoBusca) || (u.email || '').toLowerCase().includes(termoBusca))
    : [];

  // Digitando no canal ativo
  const digitandoNoCanal = canalAtivo ? Object.entries(digitandoUsuarios)
    .filter(([key]) => key.startsWith(`${canalAtivo.id}_`) && !key.endsWith(`_${user?.id}`))
    .map(([, val]) => val)
    .filter(v => Date.now() - v.timestamp < 4000) : [];

  // Filtro de busca dentro da conversa
  const termoBuscaConversa = buscaMsg.trim().toLowerCase();
  const mensagensFiltradas = termoBuscaConversa
    ? mensagens.filter(m =>
        typeof m.conteudo === 'string' && !m.deletada &&
        m.conteudo.toLowerCase().includes(termoBuscaConversa))
    : mensagens;

  // Agrupar mensagens por data + status de leitura (✓✓)
  const outrosMembros = Math.max(totalMembros - 1, 1);
  const mensagensComSeparador = [];
  let ultimaData = '';
  for (const msgOrig of mensagensFiltradas) {
    const dataMsg = formatarData(msgOrig.created_at);
    if (dataMsg !== ultimaData) {
      mensagensComSeparador.push({ tipo: 'separador', data: dataMsg, key: `sep_${msgOrig.id}` });
      ultimaData = dataMsg;
    }
    // Marca ✓✓ quando todos os outros membros já leram a mensagem própria
    let msg = msgOrig;
    if (msgOrig.usuario_id === user?.id && typeof msgOrig.id === 'number') {
      let lidaPor = 0;
      for (const [uid, ptr] of Object.entries(leituras)) {
        if (Number(uid) !== user.id && ptr >= msgOrig.id) lidaPor++;
      }
      msg = { ...msgOrig, _lida: lidaPor >= outrosMembros };
    }
    mensagensComSeparador.push(msg);
  }

  // Membros do canal ativo
  const membrosCanal = canalAtivo ? presenca.filter(u => {
    // Para simplificação, mostrar todos os usuários
    return true;
  }) : [];


  return (
    <div className={styles.chatContainer}>
      {/* ===== SIDEBAR DE CANAIS ===== */}
      <div className={styles.canalSidebar}>
        <div className={styles.canalHeader}>
          <span className={styles.canalHeaderTitle}><Icon.chat width={19} height={19} /> Chat da Equipe</span>
        </div>

        {/* Status Picker */}
        <div className={styles.statusPicker}>
          {[
            { status: 'online', cor: '#22c55e', label: 'Online' },
            { status: 'ausente', cor: '#eab308', label: 'Ausente' },
            { status: 'ocupado', cor: '#ef4444', label: 'Ocupado' }
          ].map(s => (
            <button
              key={s.status}
              className={`${styles.statusBtn} ${meuStatus === s.status ? `${styles.statusBtnAtivo} ${styles[`statusBtn${s.status.charAt(0).toUpperCase() + s.status.slice(1)}`]}` : ''}`}
              onClick={() => handleMudarStatus(s.status)}
            >
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: s.cor, display: 'inline-block', flexShrink: 0 }} /> {s.label}
            </button>
          ))}
        </div>

        {/* Campo de Busca de Usuários */}
        <div className={styles.searchWrapper}>
          <span className={styles.searchIcon}><Icon.search width={15} height={15} /></span>
          <input
            className={styles.searchInput}
            type="text"
            placeholder="Buscar pessoa para conversar..."
            value={buscaSidebar}
            onChange={e => handleBuscaChange(e.target.value)}
          />
          {buscaSidebar && (
            <button className={styles.searchClear} onClick={() => setBuscaSidebar('')}><Icon.close width={15} height={15} /></button>
          )}
        </div>

        {/* Resultados da Busca de Usuários */}
        {termoBusca && (
          <div className={styles.searchResults}>
            <div className={styles.canalSecaoTitulo}>Resultados — Usuários</div>
            {resultadosBusca.length > 0 ? (
              resultadosBusca.map(u => (
                <div
                  key={u.id}
                  className={styles.searchResultItem}
                  onClick={() => handleSelecionarUsuarioBusca(u.id)}
                >
                  <div className={styles.dmAvatar} style={{ background: getAvatarCor(u.id) }}>
                    {getIniciais(u.nome)}
                    <div className={`${styles.dmStatusDot} ${styles[`dot${(u.status_presenca || 'offline').charAt(0).toUpperCase() + (u.status_presenca || 'offline').slice(1)}`]}`} />
                  </div>
                  <div className={styles.canalInfo}>
                    <div className={styles.canalNome}>{u.nome}</div>
                    <div className={styles.canalPreview}>{u.email}</div>
                  </div>
                  <span className={styles.searchResultAction}><Icon.chat width={16} height={16} /></span>
                </div>
              ))
            ) : (
              <div className={styles.searchNoResults}>Nenhum usuário encontrado</div>
            )}
          </div>
        )}

        {/* Lista de Canais (oculta durante busca) */}
        {!termoBusca && (
        <div className={styles.canalLista}>
          {/* ═══ Canal TATUia — Assistente IA ═══ */}
          {canaisIA.map(canal => (
            <div
              key={canal.id}
              className={`${styles.canalItem} ${canalAtivo?.id === canal.id ? styles.canalItemAtivo : ''}`}
              onClick={() => selecionarCanal(canal)}
              style={{ marginBottom: '8px', background: canalAtivo?.id === canal.id ? 'rgba(124, 58, 237, 0.2)' : 'rgba(124, 58, 237, 0.08)', borderRadius: '10px', border: '1px solid rgba(124, 58, 237, 0.2)' }}
            >
              <div className={styles.dmAvatar} style={{ background: 'linear-gradient(135deg, #7c3aed, #a855f7)', color: '#fff' }}>
                <Icon.bot width={20} height={20} />
                <div className={`${styles.dmStatusDot} ${styles.dotOnline}`} />
              </div>
              <div className={styles.canalInfo}>
                <div className={styles.canalNome} style={{ color: '#a855f7', fontWeight: 700 }}>{canal.nome_exibicao || 'TATUia'}</div>
                {canal.ultima_msg_conteudo && (
                  <div className={styles.canalPreview}>
                    {canal.ultima_msg_conteudo.substring(0, 35) + (canal.ultima_msg_conteudo.length > 35 ? '...' : '')}
                  </div>
                )}
              </div>
              {canal.nao_lidas > 0 && (
                <span className={styles.canalBadge} style={{ background: '#7c3aed' }}>{canal.nao_lidas}</span>
              )}
            </div>
          ))}

          {/* Canais Fixos */}
          <div className={styles.canalSecao}>
            <div className={styles.canalSecaoTitulo}>Canais</div>
            {canaisFixos.map(canal => (
              <div
                key={canal.id}
                className={`${styles.canalItem} ${canalAtivo?.id === canal.id ? styles.canalItemAtivo : ''}`}
                onClick={() => selecionarCanal(canal)}
              >
                <span className={styles.canalIcone}>{canal.icone || <Icon.hash width={16} height={16} />}</span>
                <div className={styles.canalInfo}>
                  <div className={styles.canalNome}>#{canal.nome}</div>
                  {canal.ultima_msg_conteudo && (
                    <div className={styles.canalPreview}>
                      {canal.ultima_msg_autor}: {canal.ultima_msg_conteudo === '[Imagem]' ? '📷 Imagem' : canal.ultima_msg_conteudo === '[Áudio]' ? '🎙️ Áudio' : (canal.ultima_msg_conteudo.substring(0, 30) + (canal.ultima_msg_conteudo.length > 30 ? '...' : ''))}
                    </div>
                  )}
                </div>
                {canal.nao_lidas > 0 && (
                  <span className={styles.canalBadge}>{canal.nao_lidas}</span>
                )}
              </div>
            ))}
          </div>

          {/* Grupos Personalizados */}
          <div className={styles.canalSecao}>
            <div className={styles.canalSecaoTitulo} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              Grupos
              <button
                className={styles.novoCanalBtn}
                onClick={abrirCriarGrupo}
                title="Criar grupo"
                style={{ width: '22px', height: '22px', fontSize: '12px' }}
              >
                +
              </button>
            </div>
            {canaisGruposPersonalizados.length === 0 && (
              <div className={styles.grupoVazio}>
                Nenhum grupo criado
              </div>
            )}
            {canaisGruposPersonalizados.map(canal => (
              <div
                key={canal.id}
                className={`${styles.canalItem} ${canalAtivo?.id === canal.id ? styles.canalItemAtivo : ''}`}
                onClick={() => selecionarCanal(canal)}
              >
                {/* Avatares empilhados dos membros */}
                <div className={styles.grupoAvatares}>
                  {(canal.membros_resumo || []).slice(0, 3).map((m, idx) => (
                    <div
                      key={m.id}
                      className={styles.grupoAvatarItem}
                      style={{
                        background: getAvatarCor(m.id),
                        zIndex: 3 - idx,
                        marginLeft: idx > 0 ? '-8px' : '0'
                      }}
                      title={m.nome}
                    >
                      {getIniciais(m.nome)}
                    </div>
                  ))}
                </div>
                <div className={styles.canalInfo}>
                  <div className={styles.canalNome}>{canal.nome}</div>
                  {canal.ultima_msg_conteudo && (
                    <div className={styles.canalPreview}>
                      {canal.ultima_msg_autor}: {canal.ultima_msg_conteudo === '[Imagem]' ? '📷 Imagem' : (canal.ultima_msg_conteudo.substring(0, 30) + (canal.ultima_msg_conteudo.length > 30 ? '...' : ''))}
                    </div>
                  )}
                </div>
                <div className={styles.grupoMeta}>
                  {canal.nao_lidas > 0 && (
                    <span className={styles.canalBadge}>{canal.nao_lidas}</span>
                  )}
                  <span className={styles.grupoMembrosCount}>{canal.total_membros}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Mensagens Diretas */}
          <div className={styles.canalSecao}>
            <div className={styles.canalSecaoTitulo} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              Mensagens Diretas
              <button
                className={styles.novoCanalBtn}
                onClick={abrirNovoDM}
                title="Nova conversa"
                style={{ width: '22px', height: '22px', fontSize: '12px' }}
              >
                +
              </button>
            </div>
            {canaisDM.map(canal => {
              const outroUser = canal.dm_usuario;
              const statusPresenca = outroUser?.status_presenca || 'offline';
              return (
                <div
                  key={canal.id}
                  className={`${styles.canalItem} ${canalAtivo?.id === canal.id ? styles.canalItemAtivo : ''}`}
                  onClick={() => selecionarCanal(canal)}
                >
                  <div className={styles.dmAvatar} style={{ background: getAvatarCor(outroUser?.id) }}>
                    {getIniciais(outroUser?.nome)}
                    <div className={`${styles.dmStatusDot} ${styles[`dot${statusPresenca.charAt(0).toUpperCase() + statusPresenca.slice(1)}`]}`} />
                  </div>
                  <div className={styles.canalInfo}>
                    <div className={styles.canalNome}>{outroUser?.nome || 'Usuário'}</div>
                    {canal.ultima_msg_conteudo && (
                      <div className={styles.canalPreview}>
                        {canal.ultima_msg_conteudo === '[Imagem]' ? '📷 Imagem' : (canal.ultima_msg_conteudo.substring(0, 35) + (canal.ultima_msg_conteudo.length > 35 ? '...' : ''))}
                      </div>
                    )}
                  </div>
                  {canal.nao_lidas > 0 && (
                    <span className={styles.canalBadge}>{canal.nao_lidas}</span>
                  )}
                  <button
                    className={styles.dmRemoverBtn}
                    title="Remover conversa"
                    onClick={async (e) => {
                      e.stopPropagation();
                      if (!confirm(`Remover conversa com ${outroUser?.nome || 'este usuário'}?`)) return;
                      const result = await removerChatDM(canal.id);
                      if (result.success) {
                        setCanais(prev => prev.filter(c => c.id !== canal.id));
                        if (canalAtivo?.id === canal.id) setCanalAtivo(null);
                      }
                    }}
                  >
                    <Icon.close width={14} height={14} />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        )}
      </div>

      {/* ===== ÁREA DE MENSAGENS ===== */}
      {canalAtivo ? (
        <div className={styles.chatMain}>
          {/* Header */}
          <div className={styles.chatHeader}>
            <div className={styles.chatHeaderInfo}>
              <div>
                <div className={styles.chatHeaderNome} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                  {canalAtivo.tipo === 'ia'
                    ? (<><Icon.bot width={18} height={18} /> TATUia — Assistente IA</>)
                    : canalAtivo.tipo === 'dm'
                      ? (canalAtivo.dm_usuario?.nome || 'Conversa')
                      : canalAtivo.is_canal_fixo
                        ? (<><Icon.hash width={17} height={17} /> {canalAtivo.nome}</>)
                        : (<><Icon.users width={17} height={17} /> {canalAtivo.nome}</>)
                  }
                </div>
                {canalAtivo.tipo === 'ia' && (
                  <div className={styles.chatHeaderDesc}>Pergunte sobre vendas, estoque, clientes e métricas da Rede Gringão</div>
                )}
                {canalAtivo.tipo === 'grupo' && canalAtivo.descricao && (
                  <div className={styles.chatHeaderDesc}>{canalAtivo.descricao}</div>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div className={styles.chatHeaderMembros} onClick={() => setShowDetalhes(true)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                  <Icon.users width={14} height={14} /> {canalAtivo.total_membros} membros
                </div>
                {/* Botão rápido para adicionar membros (grupos personalizados) */}
                {canalAtivo.tipo === 'grupo' && !canalAtivo.is_canal_fixo && (
                  <button
                    className={styles.adicionarMembroHeaderBtn}
                    onClick={abrirAdicionarMembro}
                    title="Adicionar membros ao grupo"
                  >
                    + Adicionar
                  </button>
                )}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <button
                className={styles.detalhesBtn}
                onClick={() => { setBuscaAtiva(v => !v); setBuscaMsg(''); }}
                title="Buscar nesta conversa"
              >
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>{buscaAtiva ? (<><Icon.close width={14} height={14} /> Busca</>) : (<><Icon.search width={14} height={14} /> Buscar</>)}</span>
              </button>
              <button className={styles.detalhesBtn} onClick={() => setShowDetalhes(!showDetalhes)}>
                {showDetalhes ? 'Fechar' : 'Detalhes'}
              </button>
            </div>
          </div>

          {/* Barra de busca na conversa */}
          {buscaAtiva && (
            <div className={styles.buscaConversaBar}>
              <input
                className={styles.buscaConversaInput}
                placeholder="Buscar mensagens nesta conversa..."
                value={buscaMsg}
                onChange={(e) => setBuscaMsg(e.target.value)}
                autoFocus
              />
              <span className={styles.buscaConversaInfo}>
                {buscaMsg.trim()
                  ? `${mensagensFiltradas.length} resultado(s)`
                  : 'Digite para buscar'}
              </span>
            </div>
          )}

          {/* Mensagens */}
          <div className={styles.mensagensArea} ref={mensagensRef}>
            {temMais && (
              <div className={styles.carregarMais}>
                <button
                  className={styles.carregarMaisBtn}
                  onClick={() => carregarMensagens(canalAtivo.id, mensagens[0]?.id)}
                  disabled={carregando}
                >
                  {carregando ? 'Carregando...' : (<span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><Icon.arrowUp width={14} height={14} /> Carregar mensagens anteriores</span>)}
                </button>
              </div>
            )}

            {mensagensComSeparador.map((item, idx) => {
              if (item.tipo === 'separador') {
                return (
                  <div key={item.key} className={styles.dateSeparator}>
                    <span className={styles.dateSeparatorText}>{item.data}</span>
                  </div>
                );
              }

              const msg = item;
              if (msg.tipo === 'sistema') {
                return (
                  <div key={msg.id} className={styles.msgSistema}>
                    {msg.conteudo}
                  </div>
                );
              }

              const isMeu = msg.usuario_id === user?.id;
              // Agrupar mensagens consecutivas do mesmo autor (sem separador/sistema no meio, ≤5min entre elas)
              const anterior = mensagensComSeparador[idx - 1];
              const agrupada = !!anterior && anterior.tipo !== 'separador' && anterior.tipo !== 'sistema'
                && anterior.usuario_id === msg.usuario_id
                && (parseDataUTC(msg.created_at) - parseDataUTC(anterior.created_at)) < 5 * 60 * 1000;

              return (
                <div key={msg.id} className={`${styles.mensagemWrapper} ${isMeu ? styles.msgMeu : styles.msgOutro} ${agrupada ? styles.msgAgrupada : ''}`}>
                  {!isMeu && (
                    agrupada
                      ? <div className={styles.msgAvatarSpacer} />
                      : (
                        <div className={styles.msgAvatar} style={{ background: getAvatarCor(msg.usuario_id) }}>
                          {getIniciais(msg.autor_nome)}
                        </div>
                      )
                  )}
                  <div className={`${styles.msgBalao} ${isMeu ? styles.msgBalaoMeu : styles.msgBalaoOutro}`}>
                    {!isMeu && canalAtivo?.tipo !== 'dm' && !agrupada && (
                      <div className={styles.msgAutor}>{msg.autor_nome}</div>
                    )}

                    {msg.resposta_a && msg.resposta_conteudo && (
                      <div className={styles.msgResposta}>
                        <span className={styles.msgRespostaAutor}>{msg.resposta_autor_nome}:</span>
                        {msg.resposta_conteudo.substring(0, 80)}
                        {msg.resposta_conteudo.length > 80 ? '...' : ''}
                      </div>
                    )}

                    {msg.imagem && !msg.deletada && (
                      <img
                        src={msg.imagem}
                        alt="Imagem"
                        className={styles.msgImagem}
                        onClick={() => setImagemZoom(msg.imagem)}
                      />
                    )}
                    {msg.audio && !msg.deletada && (
                      <div className={styles.msgAudioPlayer}>
                        <audio controls preload="none" className={styles.audioElement}>
                          <source src={msg.audio} />
                        </audio>
                      </div>
                    )}
                    {(msg.conteudo && msg.conteudo !== '[Imagem]' && msg.conteudo !== '[Áudio]' || msg.deletada) && (
                      <div className={`${styles.msgTexto} ${msg.deletada ? styles.msgDeletada : ''}`}>
                        {msg.conteudo}
                      </div>
                    )}
                    <div className={styles.msgMeta}>
                      <span className={styles.msgHora}>{formatarHora(msg.created_at)}</span>
                      {msg.editada === 1 && <span className={styles.msgEditado}>(editada)</span>}
                      {isMeu && !msg.deletada && (
                        <span
                          className={styles.msgCheck}
                          title={msg._lida ? 'Lida por todos' : 'Enviada'}
                          style={{ color: msg._lida ? '#53bdeb' : '#9aa4ad' }}
                        >
                          {msg._lida ? '✓✓' : '✓'}
                        </span>
                      )}
                    </div>

                    {/* Reações */}
                    {Array.isArray(msg.reacoes) && msg.reacoes.length > 0 && (
                      <div className={styles.reacoesRow}>
                        {msg.reacoes.map((r) => {
                          const count = r.usuarios?.length || 0;
                          if (count === 0) return null;
                          const eu = r.usuarios?.includes(user?.id);
                          return (
                            <button
                              key={r.emoji}
                              className={`${styles.reacaoChip} ${eu ? styles.reacaoChipAtiva : ''}`}
                              onClick={() => handleReagir(msg, r.emoji)}
                            >
                              <span>{r.emoji}</span>
                              {count > 1 && <span className={styles.reacaoCount}>{count}</span>}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  {/* Ações (hover) */}
                  {!msg.deletada && (
                    <div className={styles.msgAcoes}>
                      <div className={styles.emojiPicker}>
                        <button className={styles.msgAcaoBtn} title="Reagir"><Icon.smile width={16} height={16} /></button>
                        <div className={styles.emojiPopover}>
                          {EMOJIS_REACAO.map((e) => (
                            <button
                              key={e}
                              className={styles.emojiOpcao}
                              onClick={() => handleReagir(msg, e)}
                            >
                              {e}
                            </button>
                          ))}
                        </div>
                      </div>
                      <button className={styles.msgAcaoBtn} onClick={() => handleResponder(msg)} title="Responder">
                        <Icon.reply width={16} height={16} />
                      </button>
                      {isMeu && (
                        <>
                          <button className={styles.msgAcaoBtn} onClick={() => handleEditar(msg)} title="Editar">
                            <Icon.edit width={16} height={16} />
                          </button>
                          <button className={styles.msgAcaoBtn} onClick={() => handleDeletar(msg)} title="Deletar">
                            <Icon.trash width={16} height={16} />
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            {mensagens.length === 0 && !carregando && (
              <div className={styles.emptyState}>
                <div className={styles.emptyIcon}><Icon.sparkles width={44} height={44} /></div>
                <div className={styles.emptyTitle}>Início da conversa</div>
                <div className={styles.emptySubtitle}>
                  Seja o primeiro a enviar uma mensagem neste canal!
                </div>
              </div>
            )}
          </div>

          {/* Digitando */}
          <div className={styles.digitandoIndicador}>
            {digitandoNoCanal.length > 0 && (
              <>
                <span className={styles.digitandoDots}>
                  <span /><span /><span />
                </span>
                {digitandoNoCanal.length === 1
                  ? `${digitandoNoCanal[0].nome} está digitando...`
                  : `${digitandoNoCanal.length} pessoas estão digitando...`
                }
              </>
            )}
          </div>

          {/* Input */}
          <div className={styles.inputArea}>
            {respondendoA && (
              <div className={styles.inputRespondendo}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><Icon.reply width={14} height={14} /> Respondendo a <strong>{respondendoA.autor_nome}</strong>: {respondendoA.conteudo?.substring(0, 50)}{respondendoA.conteudo?.length > 50 ? '...' : ''}</span>
                <button className={styles.inputRespondendoFechar} onClick={() => setRespondendoA(null)}><Icon.close width={15} height={15} /></button>
              </div>
            )}
            {editandoMsg && (
              <div className={styles.inputRespondendo}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><Icon.edit width={14} height={14} /> Editando mensagem</span>
                <button className={styles.inputRespondendoFechar} onClick={() => { setEditandoMsg(null); setInputMsg(''); }}><Icon.close width={15} height={15} /></button>
              </div>
            )}
            {imagemPendente && (
              <div className={styles.imagemPreviewArea}>
                <img src={imagemPendente} alt="Preview" className={styles.imagemPreview} />
                <button className={styles.imagemPreviewRemover} onClick={() => setImagemPendente(null)} title="Remover imagem"><Icon.close width={15} height={15} /></button>
              </div>
            )}
            {audioPendente && (
              <div className={styles.audioPreviewArea}>
                <span className={styles.audioPreviewIcon}><Icon.mic width={16} height={16} /></span>
                <span className={styles.audioPreviewTexto}>Áudio gravado — pronto para enviar</span>
                <button className={styles.imagemPreviewRemover} onClick={() => setAudioPendente(null)} title="Remover áudio" style={{ position: 'static' }}><Icon.close width={15} height={15} /></button>
              </div>
            )}
            <div className={styles.inputWrapper}>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleAnexarImagem}
              />
              {gravandoAudio ? (
                <>
                  <div className={styles.gravandoIndicador}>
                    <span className={styles.gravandoPulse} />
                    <span className={styles.gravandoTempo}>Gravando... 0:{duracaoGravacao < 10 ? `0${duracaoGravacao}` : duracaoGravacao}</span>
                  </div>
                  <button
                    className={styles.anexarBtn}
                    onClick={cancelarGravacaoAudio}
                    title="Cancelar gravação"
                    type="button"
                  >
                    <Icon.trash />
                  </button>
                  <button
                    className={styles.enviarBtn}
                    onClick={pararGravacaoAudio}
                    title="Parar gravação"
                    style={{ background: '#ef4444' }}
                  >
                    <Icon.stop />
                  </button>
                </>
              ) : (
                <>
                  <button
                    className={styles.anexarBtn}
                    onClick={() => fileInputRef.current?.click()}
                    title="Anexar imagem"
                    type="button"
                  >
                    <Icon.attach />
                  </button>
                  <button
                    className={styles.anexarBtn}
                    onClick={iniciarGravacaoAudio}
                    title="Gravar áudio"
                    type="button"
                  >
                    <Icon.mic />
                  </button>
                  <textarea
                    ref={inputRef}
                    className={styles.inputCampo}
                    placeholder={canalAtivo.tipo === 'ia' ? 'Pergunte algo ao Tatu IA...' : `Mensagem para ${canalAtivo.tipo === 'dm' ? canalAtivo.dm_usuario?.nome : '#' + canalAtivo.nome}...`}
                    value={inputMsg}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    rows={1}
                  />
                  <button
                    className={styles.enviarBtn}
                    onClick={handleEnviar}
                    disabled={!inputMsg.trim() && !imagemPendente && !audioPendente}
                    title="Enviar (Enter)"
                  >
                    <Icon.send />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.chatMain}>
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}><Icon.chat width={44} height={44} /></div>
            <div className={styles.emptyTitle}>Chat da Equipe</div>
            <div className={styles.emptySubtitle}>
              Selecione um canal ou conversa para começar
            </div>
          </div>
        </div>
      )}

      {/* ===== PAINEL DE DETALHES ===== */}
      {showDetalhes && canalAtivo && (
        <div className={styles.painelDetalhes}>
          <div className={styles.painelHeader}>
            <span className={styles.painelTitulo}>Detalhes</span>
            <button className={styles.painelFechar} onClick={() => setShowDetalhes(false)}><Icon.close width={15} height={15} /></button>
          </div>
          <div className={styles.painelConteudo}>
            {/* Configurações do grupo — edição apenas para admin de grupo personalizado */}
            {canalAtivo.tipo === 'grupo' && !canalAtivo.is_canal_fixo && canalAtivo.minha_role === 'admin' ? (
              <div className={styles.painelSecao}>
                <div className={styles.painelSecaoTitulo} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  Configurações do grupo
                  {!editandoGrupo && (
                    <button
                      className={styles.detalhesBtn}
                      style={{ padding: '3px 10px', fontSize: '12px' }}
                      onClick={() => {
                        setGrupoEditNome(canalAtivo.nome || '');
                        setGrupoEditDescricao(canalAtivo.descricao || '');
                        setEditandoGrupo(true);
                      }}
                    >
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><Icon.edit width={13} height={13} /> Editar</span>
                    </button>
                  )}
                </div>
                {editandoGrupo ? (
                  <>
                    <input
                      className={styles.buscaConversaInput}
                      style={{ width: '100%', marginBottom: '8px' }}
                      value={grupoEditNome}
                      onChange={(e) => setGrupoEditNome(e.target.value)}
                      placeholder="Nome do grupo"
                      maxLength={60}
                    />
                    <textarea
                      className={styles.buscaConversaInput}
                      style={{ width: '100%', minHeight: '60px', resize: 'vertical', marginBottom: '8px' }}
                      value={grupoEditDescricao}
                      onChange={(e) => setGrupoEditDescricao(e.target.value)}
                      placeholder="Descrição do grupo"
                      maxLength={200}
                    />
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button className={styles.detalhesBtn} onClick={() => setEditandoGrupo(false)}>
                        Cancelar
                      </button>
                      <button className={styles.adicionarMembroHeaderBtn} onClick={handleSalvarEdicaoGrupo}>
                        Salvar
                      </button>
                    </div>
                  </>
                ) : (
                  <div className={styles.painelDescricao}>
                    {canalAtivo.descricao || 'Sem descrição'}
                  </div>
                )}
              </div>
            ) : (
              canalAtivo.descricao && (
                <div className={styles.painelSecao}>
                  <div className={styles.painelSecaoTitulo}>Descrição</div>
                  <div className={styles.painelDescricao}>{canalAtivo.descricao}</div>
                </div>
              )
            )}

            {/* Membros — para grupos personalizados, mostrar lista real com ações */}
            {canalAtivo.tipo === 'grupo' && !canalAtivo.is_canal_fixo && membrosGrupoAtivo.length > 0 ? (
              <div className={styles.painelSecao}>
                <div className={styles.painelSecaoTitulo} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  Membros ({membrosGrupoAtivo.length})
                  <button
                    className={styles.novoCanalBtn}
                    onClick={abrirAdicionarMembro}
                    title="Adicionar membro"
                    style={{ width: '22px', height: '22px', fontSize: '12px' }}
                  >
                    +
                  </button>
                </div>
                {membrosGrupoAtivo.map(m => (
                  <div key={m.id} className={styles.painelMembro}>
                    <div className={styles.painelMembroAvatar} style={{ background: getAvatarCor(m.id) }}>
                      {getIniciais(m.nome)}
                      <div
                        className={`${styles.dmStatusDot} ${styles[`dot${(m.status_presenca || 'offline').charAt(0).toUpperCase() + (m.status_presenca || 'offline').slice(1)}`]}`}
                        style={{ width: '8px', height: '8px' }}
                      />
                    </div>
                    <span className={styles.painelMembroNome}>{m.nome}</span>
                    {m.role_grupo === 'admin' && <span className={styles.painelMembroRole}>Admin</span>}
                    {/* Botão remover (somente admin pode, e não pode remover a si mesmo) */}
                    {canalAtivo.minha_role === 'admin' && m.id !== user?.id && (
                      <button
                        className={styles.membroRemoverBtn}
                        onClick={() => handleRemoverMembro(m.id, m.nome)}
                        title={`Remover ${m.nome}`}
                      >
                        <Icon.close width={13} height={13} />
                      </button>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.painelSecao}>
                <div className={styles.painelSecaoTitulo}>Membros ({presenca.length})</div>
                {presenca.map(u => (
                  <div key={u.id} className={styles.painelMembro}>
                    <div className={styles.painelMembroAvatar} style={{ background: getAvatarCor(u.id) }}>
                      {getIniciais(u.nome)}
                      <div
                        className={`${styles.dmStatusDot} ${styles[`dot${(u.status || 'offline').charAt(0).toUpperCase() + (u.status || 'offline').slice(1)}`]}`}
                        style={{ width: '8px', height: '8px' }}
                      />
                    </div>
                    <span className={styles.painelMembroNome}>{u.nome}</span>
                    {u.role === 'admin' && <span className={styles.painelMembroRole}>Admin</span>}
                  </div>
                ))}
              </div>
            )}

            {/* Botão sair do grupo (somente para grupos personalizados) */}
            {canalAtivo.tipo === 'grupo' && !canalAtivo.is_canal_fixo && (
              <div className={styles.painelSecao} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <button className={styles.sairGrupoBtn} onClick={handleSairDoGrupo} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 7 }}>
                  <Icon.leave width={15} height={15} /> Sair do grupo
                </button>
                {/* Excluir grupo — apenas admin */}
                {canalAtivo.minha_role === 'admin' && (
                  <button className={styles.excluirGrupoBtn} onClick={handleExcluirGrupo} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 7 }}>
                    <Icon.trash width={15} height={15} /> Excluir grupo
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ===== MODAL NOVO CANAL ===== */}
      {showNovoCanal && (
        <div className={styles.modalOverlay} onClick={() => setShowNovoCanal(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.modalTitulo}>Criar Novo Canal</div>
            <div className={styles.modalCampo}>
              <label className={styles.modalLabel}>Nome do Canal</label>
              <input
                className={styles.modalInput}
                placeholder="ex: marketing"
                value={novoCanal.nome}
                onChange={e => setNovoCanal({ ...novoCanal, nome: e.target.value })}
                autoFocus
              />
            </div>
            <div className={styles.modalCampo}>
              <label className={styles.modalLabel}>Descrição (opcional)</label>
              <input
                className={styles.modalInput}
                placeholder="Sobre o que é este canal..."
                value={novoCanal.descricao}
                onChange={e => setNovoCanal({ ...novoCanal, descricao: e.target.value })}
              />
            </div>
            <div className={styles.modalAcoes}>
              <button className={styles.modalCancelar} onClick={() => setShowNovoCanal(false)}>Cancelar</button>
              <button className={styles.modalCriar} onClick={handleCriarCanal} disabled={!novoCanal.nome.trim()}>Criar Canal</button>
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL CRIAR GRUPO (2 etapas) ===== */}
      {showCriarGrupo && (
        <div className={styles.modalOverlay} onClick={() => setShowCriarGrupo(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()} style={{ maxWidth: '480px' }}>
            {/* Stepper */}
            <div className={styles.grupoStepper}>
              <div className={`${styles.grupoStep} ${grupoEtapa >= 1 ? styles.grupoStepAtivo : ''}`}>
                <span className={styles.grupoStepNum}>1</span>
                <span>Informações</span>
              </div>
              <div className={styles.grupoStepLine} />
              <div className={`${styles.grupoStep} ${grupoEtapa >= 2 ? styles.grupoStepAtivo : ''}`}>
                <span className={styles.grupoStepNum}>2</span>
                <span>Membros</span>
              </div>
            </div>

            {grupoEtapa === 1 ? (
              <>
                <div className={styles.modalTitulo} style={{ display: 'flex', alignItems: 'center', gap: 8 }}><Icon.users width={18} height={18} /> Criar Novo Grupo</div>
                <div className={styles.modalCampo}>
                  <label className={styles.modalLabel}>Nome do Grupo</label>
                  <input
                    className={styles.modalInput}
                    placeholder="ex: Equipe de Vendas"
                    value={novoGrupo.nome}
                    onChange={e => setNovoGrupo({ ...novoGrupo, nome: e.target.value })}
                    autoFocus
                  />
                </div>
                <div className={styles.modalCampo}>
                  <label className={styles.modalLabel}>Descrição (opcional)</label>
                  <input
                    className={styles.modalInput}
                    placeholder="Sobre o que é este grupo..."
                    value={novoGrupo.descricao}
                    onChange={e => setNovoGrupo({ ...novoGrupo, descricao: e.target.value })}
                  />
                </div>
                <div className={styles.modalAcoes}>
                  <button className={styles.modalCancelar} onClick={() => setShowCriarGrupo(false)}>Cancelar</button>
                  <button
                    className={styles.modalCriar}
                    onClick={() => setGrupoEtapa(2)}
                    disabled={!novoGrupo.nome.trim()}
                  >
                    Próximo →
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className={styles.modalTitulo}>Selecionar Membros</div>
                <div className={styles.modalCampo}>
                  <input
                    className={styles.modalInput}
                    placeholder="Buscar usuários..."
                    value={grupoBusca}
                    onChange={e => setGrupoBusca(e.target.value)}
                    autoFocus
                  />
                </div>
                {grupoMembrosSelecionados.length > 0 && (
                  <div className={styles.grupoSelecionadosBar}>
                    {grupoMembrosSelecionados.map(uid => {
                      const u = grupoUsuariosDisponiveis.find(x => x.id === uid);
                      return u ? (
                        <span key={uid} className={styles.grupoSelecionadoTag}>
                          {u.nome}
                          <button onClick={() => toggleGrupoMembro(uid)} className={styles.grupoSelecionadoRemover}><Icon.close width={15} height={15} /></button>
                        </span>
                      ) : null;
                    })}
                  </div>
                )}
                <div className={styles.grupoUsuariosLista}>
                  {grupoUsuariosDisponiveis
                    .filter(u => !grupoBusca.trim() || u.nome.toLowerCase().includes(grupoBusca.toLowerCase()))
                    .map(u => {
                      const selecionado = grupoMembrosSelecionados.includes(u.id);
                      return (
                        <div
                          key={u.id}
                          className={`${styles.grupoUsuarioItem} ${selecionado ? styles.grupoUsuarioSelecionado : ''}`}
                          onClick={() => toggleGrupoMembro(u.id)}
                        >
                          <div className={styles.grupoCheckbox}>
                            {selecionado && <span style={{ display: 'inline-flex' }}><Icon.check width={14} height={14} /></span>}
                          </div>
                          <div className={styles.dmAvatar} style={{ background: getAvatarCor(u.id), width: '32px', height: '32px', fontSize: '11px' }}>
                            {getIniciais(u.nome)}
                          </div>
                          <div className={styles.canalInfo}>
                            <div className={styles.canalNome}>{u.nome}</div>
                            <div className={styles.canalPreview}>{u.email}</div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
                <div className={styles.modalAcoes}>
                  <button className={styles.modalCancelar} onClick={() => setGrupoEtapa(1)} style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><Icon.arrowLeft width={14} height={14} /> Voltar</button>
                  <button
                    className={styles.modalCriar}
                    onClick={handleCriarGrupo}
                    disabled={grupoMembrosSelecionados.length === 0}
                  >
                    Criar Grupo ({grupoMembrosSelecionados.length})
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ===== MODAL ADICIONAR MEMBROS AO GRUPO ===== */}
      {showAdicionarMembro && (
        <div className={styles.modalOverlay} onClick={() => setShowAdicionarMembro(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()} style={{ maxWidth: '420px' }}>
            <div className={styles.modalTitulo}>Adicionar Membros</div>
            <div className={styles.modalCampo}>
              <input
                className={styles.modalInput}
                placeholder="Buscar usuários..."
                value={addMembroBusca}
                onChange={e => setAddMembroBusca(e.target.value)}
                autoFocus
              />
            </div>
            <div className={styles.grupoUsuariosLista}>
              {addMembroUsuarios
                .filter(u => !addMembroBusca.trim() || u.nome.toLowerCase().includes(addMembroBusca.toLowerCase()))
                .map(u => {
                  const selecionado = addMembroSelecionados.includes(u.id);
                  return (
                    <div
                      key={u.id}
                      className={`${styles.grupoUsuarioItem} ${selecionado ? styles.grupoUsuarioSelecionado : ''}`}
                      onClick={() => {
                        setAddMembroSelecionados(prev =>
                          prev.includes(u.id) ? prev.filter(id => id !== u.id) : [...prev, u.id]
                        );
                      }}
                    >
                      <div className={styles.grupoCheckbox}>
                        {selecionado && <span style={{ display: 'inline-flex' }}><Icon.check width={14} height={14} /></span>}
                      </div>
                      <div className={styles.dmAvatar} style={{ background: getAvatarCor(u.id), width: '32px', height: '32px', fontSize: '11px' }}>
                        {getIniciais(u.nome)}
                      </div>
                      <span className={styles.painelMembroNome}>{u.nome}</span>
                    </div>
                  );
                })
              }
              {addMembroUsuarios.filter(u => !addMembroBusca.trim() || u.nome.toLowerCase().includes(addMembroBusca.toLowerCase())).length === 0 && (
                <div className={styles.searchNoResults}>Todos os usuários já são membros</div>
              )}
            </div>
            <div className={styles.modalAcoes}>
              <button className={styles.modalCancelar} onClick={() => setShowAdicionarMembro(false)}>Cancelar</button>
              <button
                className={styles.modalCriar}
                onClick={handleAdicionarMembros}
                disabled={addMembroSelecionados.length === 0}
              >
                Adicionar ({addMembroSelecionados.length})
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL NOVO DM ===== */}
      {showNovoDM && (
        <div className={styles.modalOverlay} onClick={() => setShowNovoDM(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.modalTitulo}>Nova Conversa</div>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {usuarios.map(u => (
                <div
                  key={u.id}
                  className={styles.painelMembro}
                  style={{ cursor: 'pointer', padding: '10px 8px' }}
                  onClick={() => handleNovoDM(u.id)}
                >
                  <div className={styles.dmAvatar} style={{ background: getAvatarCor(u.id), width: '36px', height: '36px' }}>
                    {getIniciais(u.nome)}
                    <div className={`${styles.dmStatusDot} ${styles[`dot${(u.status_presenca || 'offline').charAt(0).toUpperCase() + (u.status_presenca || 'offline').slice(1)}`]}`} />
                  </div>
                  <span className={styles.painelMembroNome} style={{ fontSize: '14px' }}>{u.nome}</span>
                </div>
              ))}
            </div>
            <div className={styles.modalAcoes}>
              <button className={styles.modalCancelar} onClick={() => setShowNovoDM(false)}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* ===== LIGHTBOX DE IMAGEM ===== */}
      {imagemZoom && (
        <div className={styles.lightbox} onClick={() => setImagemZoom(null)}>
          <img src={imagemZoom} alt="Imagem" className={styles.lightboxImg} />
          <button className={styles.lightboxFechar} onClick={() => setImagemZoom(null)}><Icon.close width={15} height={15} /></button>
        </div>
      )}
    </div>
  );
};

export default ChatPage;
